import { useDispatch } from 'react-redux'
import DocumentListIndex from './List'
import { BasePathProvider, MemberProvider, useMember } from 'components/Providers'
import { hasFullPermission } from 'store'
import * as action from 'store/member/document'
import { useEffect, useState } from 'react'
import { Drawer } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
/* import DocumentListSkeleton from './List/ListSkeleton'
 */import Header from 'components/Header'
import DocumentFormIndex from './Form'
import { isInteger } from 'lodash'

export default function DocumentsPage() {
  const dispatch = useDispatch()
  const member = useMember()
  const { employmentType, memberId, documentId } = useParams()
  const [document, setDocument] = useState(null)
  const [documentLoading, setDocumentLoading] = useState(false)

  const navigate = useNavigate()

  const basePath = `/member/${member?.person?.type}/${member?.id}/documents`

  useEffect(() => {
    member && !member.documents && dispatch(action.search({ type: member.person?.type, memberId: member?.id }))
  }, [dispatch, member])

  useEffect(() => {
    if (isInteger(+documentId)) {
      setDocumentLoading(true)
      dispatch(action.retrieve({ id: documentId, type: employmentType, memberId })).then(res => {
        setDocument(res.payload)
        setDocumentLoading(false)
      })
    } else {
      setDocument({})
      setDocumentLoading(false)
    }
  }, [dispatch, documentId])

  return (
    <BasePathProvider value={`${basePath}`}>
      <MemberProvider member={member}>
        {hasFullPermission('student.document') && (
          <Header small title={''} add />
        )}
        <DocumentListIndex documents={member?.documents} />
        <Drawer
          PaperProps={{
            sx: {
              width: 600,
            },
          }}
          open={Boolean(documentId)}
          anchor="right"
          onClose={() => navigate(`${basePath}`)}
        >
          <DocumentFormIndex document={document} loading={documentLoading} />
        </Drawer>
      </MemberProvider>
    </BasePathProvider>
  )
}
